import React from 'react'
import * as dayjs from 'dayjs'

export const OffersContext = React.createContext({})

export const isExpired = (row) => dayjs(row.fecha_hasta) < new Date()
